import Script from "next/script";
import type { GtagConsent } from "./types";

type Props = {
	gtmId: string;
	defaultConsent?: GtagConsent;
	onLoad?: () => void;
};

export function GoogleTagManagerScripts({
	gtmId,
	defaultConsent = "denied",
	onLoad,
}: Props) {
	const initScriptContent = `
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js'
		});
		window.gtag = function(){ window.dataLayer.push(arguments); };
		window.gtag('js', new Date());
		window.gtag('consent', 'default', {
			ad_storage: '${defaultConsent}',
			analytics_storage: '${defaultConsent}',
			personalization_storage: '${defaultConsent}',
			functionality_storage: '${defaultConsent}',
			security_storage: '${defaultConsent}',
			ad_user_data: '${defaultConsent}',
			ad_personalization: '${defaultConsent}',
		});
		window.gtag('config', '${gtmId}', {
			page_path: window.location.pathname,
		});
	`;

	return (
		<>
			<Script
				id="gtm-init"
				strategy="beforeInteractive"
				// biome-ignore lint/security/noDangerouslySetInnerHtml: GTM initialization requires inline script
				dangerouslySetInnerHTML={{ __html: initScriptContent }}
			/>
			<Script
				id="gtm-script"
				src={`https://www.googletagmanager.com/gtm.js?id=${gtmId}`}
				strategy="afterInteractive"
				onLoad={onLoad}
			/>
		</>
	);
}
